import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from '../utils';
function getListQuery(qpID) {
    return db.qnaNode
        .where('ancestors')
        .equals(qpID)
        .and(node => [NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(node.type) &&
        !node.deleted);
}
export const getList = async (userID, qpID, pagination = { offset: 0 }) => {
    const { offset = 0, limit = 20 } = pagination;
    const query = getListQuery(qpID);
    const questions = await query
        .offset(offset)
        .limit(limit)
        .sortBy('data.sequence');
    const totalCount = await getListQuery(qpID).count();
    return {
        list: questions.map(getSafeData),
        totalCount,
    };
};
